import { render, staticRenderFns } from "./PageRoomIns.vue?vue&type=template&id=8ad41496&scoped=true&"
import script from "./PageRoomIns.vue?vue&type=script&lang=js&"
export * from "./PageRoomIns.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ad41496",
  null
  
)

export default component.exports